import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRepository } from '../../../../shared/infrastructure/api.repository';
import { DeliveryRepositoryPort } from '../../domain/repositories/delivery.repository.port';

@Injectable({ providedIn: 'root' })
export class DeliveryRepository extends ApiRepository implements DeliveryRepositoryPort {
  private readonly baseUrl = '/deliveries';

  generateDocument(qualityControlId: string): Observable<Blob> {
    return this.http.get(`${this.baseApiUrl}${this.baseUrl}/${qualityControlId}/testPdf`, {
      responseType: 'blob',
    });
  }
}
